module.exports = __webpack_public_path__ + "static/media/reply.72ba8cdc.svg";